<template>
  <div class="fb fb-col h-full sign-in-class">
    <commonSelection
      class="h-78 bt"
      :select-depts="selectDepts"
      :showReports="true"
      :selectType="0"
      :show-clear="false"
      :clearable="false"
      @handleReport="goReportsPage"
      @handleReset="handlerResetFilter"
      @changeClass="handlerChangeClass"
      @clear-class="handlerClearClass"
      @date-click="getDate"
    ></commonSelection>
    <div ref="scrollContainer" class="item-flex-1 class-list scroll-y relative">
      <template v-if="(courseClassList || []).length">
        <div
          v-for="(item, index) in courseClassList"
          :key="`${item.courseClassId}-${index}`"
          class="class-item"
          @click="viewDetail(item)"
        >
          <div
            class="bg-FFFFFF bd-radio-8 p-0-16 mt-12 m-0-16 p-12 font-28 c-111F2C-56"
          >
            <p class="font-34 c-111F2C">{{ item.courseClassName }}</p>
            <p class="mt-8">
              上课时间：{{ item.beginTime }} - {{ item.endTime }}
            </p>
            <p class="mt-8">
              任课老师：{{ filterName(item.teacherName, 5) || ' -' }}
            </p>
            <p class="mt-8"> 上课地点：{{ item.spaceName || ' -' }} </p>
            <div
              class="fb fb-cross-center fb-main-around text-center mt-12 font-24"
            >
              <div class="">
                <p class="c-111F2C font-30 text-bold">{{ item.signCount }}</p>
                <p>已签到</p>
              </div>
              <div>
                <p class="c-111F2C font-30 text-bold">{{
                  item.notSignCount
                }}</p>
                <p>未签到</p>
              </div>
              <div>
                <p class="c-111F2C font-30 text-bold">{{ item.leaveCount }}</p>
                <p>请假</p>
              </div>
            </div>
          </div>
        </div>
        <div class="pb-72"></div>
      </template>
      <template v-else>
        <common-no-data class="common-no-record">
          <div class="no-item"></div>
          <p class="font-28 c-171A1D-40">暂无数据</p>
        </common-no-data>
      </template>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixin/index.js'
import commonSelection from './commonSelection.vue'
import { timeFormat, filterName } from '@/utils/comUtils'
import commonNoData from './commonNoData.vue'
import API from '@/api'

export default {
  mixins: [mixin],
  name: 'SignInClass',
  components: {
    commonSelection,
    commonNoData
  },
  props: {
    dateStr: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      filterName,
      searchDate: timeFormat(new Date(), 'YYYY-MM-DD'),
      selectDepts: [],
      courseClassList: [],
      classState: {
        1: '待签到',
        3: '未上课',
        2: '已签到'
      },
      classData: [],
      scrollTop: 0
    }
  },
  computed: {
    cpselectionChange() {
      return this.searchDate + JSON.stringify(this.classData)
    }
  },
  watch: {
    cpselectionChange: {
      handler(newVal, oldVal) {
        this.getClassList()
      },
      immediate: true
    }
  },
  methods: {
    getDate(dateStr) {
      this.searchDate = dateStr
    },
    goReportsPage() {
      this.$router.push('/studentSign/reports')
    },
    handlerResetFilter() {
      this.searchDate = ''
    },
    handlerChangeClass(classData) {
      if (!classData || !classData.length) {
        return false
      }
      this.classData = classData
    },
    handlerClearClass() {
      this.classData = []
    },
    // 保存滚动位置
    saveScrollPosition() {
      const scrollContainer = this.$refs.scrollContainer
      if (scrollContainer) {
        this.scrollTop = scrollContainer.scrollTop
      }
    },
    // 恢复滚动位置
    restoreScrollPosition() {
      this.$nextTick(() => {
        const scrollContainer = this.$refs.scrollContainer
        if (scrollContainer && this.scrollTop) {
          scrollContainer.scrollTop = this.scrollTop
        }
      })
    },
    viewDetail(item) {
      // 保存当前滚动位置
      this.saveScrollPosition()
      // 跳转到签到详情页面
      // 1) 先把当前点击的卡片信息存入store，供详情页读取
      this.$store.commit('setSignInClassItem', item)
      this.$router.push({
        path: '/studentSign/index/signDetail',
        query: {
          dimDay: this.searchDate.replace(/-/gi, '')
        }
      })
    },
    // 获取行政班数据的方法
    async getClassList() {
      try {
        const res = await API.getSignInClassList({
          dimDay: this.searchDate.replace(/-/gi, ''),
          deptSearchReqList: (this.classData || []).map(item => {
            return {
              deptDingId: item.deptDingId,
              deptType: item.deptType
            }
          }),
          ...this.commonTerm,
          ...this.commonParams
        })
        this.courseClassList = res.courseClassList || []
      } catch (error) {}
    }
  },
  mounted() {},
  activated() {
    // 页面激活时恢复滚动位置
    this.restoreScrollPosition()
  },
  deactivated() {}
}
</script>

<style lang="scss" scoped>
.sign-in-class {
  .no-record {
    .no-clearplate {
      width: 180px;
      height: 180px;
      background: url(~@/assets/images/no-data.png) no-repeat center top;
      background-size: 180px 180px;
    }
  }
}
</style>
